'use client';

import React from 'react';
import { twMerge } from 'tailwind-merge';

interface CardProps {
  children: React.ReactNode;
  variant?: 'outlined' | 'elevation';
  className?: string;
  component?: React.ElementType;
}

export const Card: React.FC<CardProps> = ({
  children,
  variant = 'elevation',
  className = '',
  component: Component = 'div',
  ...other
}) => {
  // Base classes
  const baseClasses = 'rounded-lg overflow-hidden';

  // Variant classes
  const variantClasses = {
    outlined: 'border border-gray-200',
    elevation: 'shadow-md bg-white',
  }[variant];

  // Combine all classes
  const cardClasses = twMerge(baseClasses, variantClasses, className);

  return (
    <Component className={cardClasses} {...other}>
      {children}
    </Component>
  );
};

export default Card;
